<template>
  <d2-container>
    <template slot="header">
      <el-input v-model="query.subscriptionId" clearable size="small" placeholder="订阅ID" style="width: 160px; margin-right: 8px"></el-input>
      <el-input v-model="query.organizationId" clearable size="small" placeholder="组织ID" style="width: 160px; margin-right: 8px"></el-input>
      <el-input v-model="query.accountId" clearable size="small" placeholder="账户ID" style="width: 160px; margin-right: 8px"></el-input>
      <el-select v-model="query.status" clearable size="small" placeholder="状态" style="width: 120px; margin-right: 8px">
        <el-option label="启用" :value="1"></el-option>
        <el-option label="停用" :value="0"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="席位ID" width="150"></el-table-column>
      <el-table-column prop="subscriptionId" label="订阅ID" width="150"></el-table-column>
      <el-table-column prop="organizationId" label="组织ID" width="150"></el-table-column>
      <el-table-column prop="accountId" label="账户ID" width="150"></el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.status === 1 ? '启用' : '停用' }}</template>
      </el-table-column>
      <el-table-column prop="assignedBy" label="分配人" width="150"></el-table-column>
      <el-table-column prop="assignedAt" label="分配时间" width="170"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>
  </d2-container>
</template>

<script>
import { getSubscriptionSeats } from '@/api/ai/rights'

export default {
  name: 'aiSubscriptionSeatManager',
  data () {
    return {
      query: { currentPage: 1, pageSize: 20, subscriptionId: '', organizationId: '', accountId: '', status: '' },
      records: [],
      total: 0,
      loading: false
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      getSubscriptionSeats(this.query).then(res => {
        this.records = (res && res.records) || []
        this.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    }
  }
}
</script>

